import type { MenuSection } from '../types';
import { companyMenu } from './company';
import { generalMenu } from './general';
import { hiringMenu } from './hiring';

export const generateMenu = () =>
  [hiringMenu(), companyMenu(), generalMenu()] as MenuSection[];
